export default "__VITE_ASSET__Qwpb8tPA__"